export default "__VITE_ASSET__1nTYwHLI__"